import type { Campaign } from 'features/campaigns'
import type { Team } from 'features/team'

import { CONSTS } from 'config/objectConst'
import { wrapExistProxy } from 'shared/utils'
const adaptPersona = ({
	added,
	email,
	linkedin_profile,
	nickname,
	pending,
	persona_id,
	role,
	subscription
}: Team.Persona) => ({
	added,
	avatar: linkedin_profile?.picture_url,
	email,
	entityId: linkedin_profile?.linkedin_entity_id,
	id: persona_id,
	linkedin_profile,
	nickname,
	pending,
	publicIdentifier: linkedin_profile?.linkedin_public_identifier,
	role,
	subscription
})

const stepTypeToName: Partial<Record<Campaign.CampaignStepType, string>> =
	wrapExistProxy({
		Connect: CONSTS.AVAILABLE_ACTIONS.Connect.Title,
		EndorseSkill: CONSTS.AVAILABLE_ACTIONS.EndorseSkill.Title,
		Follow: CONSTS.AVAILABLE_ACTIONS.Follow.Title,
		Message: CONSTS.AVAILABLE_ACTIONS.Message.Title,
		ReactOnPost: CONSTS.AVAILABLE_ACTIONS.ReactOnPost.Title,
		ScrapeProfile: CONSTS.AVAILABLE_ACTIONS.ScrapeProfile.Title,
		VisitProfile: CONSTS.AVAILABLE_ACTIONS.VisitProfile.Title
	})

function legacyAdaptCampaignStep(step: Campaign.Step, id = 0) {
	const { type } = step

	const isReact = type === 'ReactOnPost'

	return {
		arrow: type === 'Connect' || type === 'Message' || isReact,
		id,
		index: `Action_${id}`,
		information: [],
		mainCustomFields: isReact && CONSTS.MAIN_CUSTOM_FIELDS,
		name: stepTypeToName[type],
		open: false,
		params: {
			currentEmotion: isReact && step.reaction,
			emotion: isReact && CONSTS.EMOTION,
			launchActionIn: false,
			mainCustomFields: !isReact && CONSTS.MAIN_CUSTOM_FIELDS,
			overflowCustomFields: !isReact && CONSTS.OVERFLOW_CUSTOM_FIELDS,
			period: isReact || Number,
			sendMessageTo: false,
			textarea: !isReact && String
		},
		status: false,
		type,
		validation: {
			actionName: true,
			textarea: true
		},
		values: {
			currentEmotion: isReact && step.reaction,
			delay: 0,
			launchActionIn: 0,
			mainCustomFields: CONSTS.MAIN_CUSTOM_FIELDS,
			overflowCustomFields: CONSTS.OVERFLOW_CUSTOM_FIELDS,
			period: step.timeout,
			sendMessageTo: '',
			textarea: step.message_template
		}
	}
}

const buildCampaignsSteps = (steps: Campaign.Step[]) => {
	let connectIndex = -1,
		delay = CONSTS.DEFAULT_DATE_ACTIONS_VALUE.CONNECT.DELAY.DEFAULT,
		id = 0

	const adapted = steps.reduce<LegacyAction[]>((adaptedSteps, step) => {
		if (step.type === 'Connect') {
			connectIndex = id
		}

		if (step.type === 'Delay') {
			delay = step.timeout
		} else {
			const adaptedStep = legacyAdaptCampaignStep(step, ++id)
			adaptedSteps.push(adaptedStep)
		}

		return adaptedSteps
	}, [])

	if (connectIndex !== -1) {
		adapted[connectIndex].values.delay = delay
	}

	return adapted
}

export type LegacyAction = ReturnType<typeof legacyAdaptCampaignStep>
export {
	adaptPersona,
	buildCampaignsSteps,
	legacyAdaptCampaignStep,
	stepTypeToName
}
